import {
  FETCH_BASKET_PENDING,
  FETCH_BASKET_REJECTED,
  FETCH_BASKET_FULFILLED,
  FETCH_VOUCHERCODE_REJECTED,
  FETCH_CUSTOMER_FULFILLED,
  REMOVE_BASKET_ITEMS,
  COMPLETE_CALL_CENTER_FULFILLED
} from "constants/basket";


const initialState = {
  basket: {},
  basketItems: [],
  customer: {},
  pending: true,
  error: {},
  logged_in: false
};

export const basket = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_BASKET_ITEMS: 
      return {
        basket: {},
        basketItems: [],
        customer: {},
        pending: true,
        error: {},
        logged_in: false
      };

    case COMPLETE_CALL_CENTER_FULFILLED: 
       return {
        result: true,
      };

    case FETCH_BASKET_PENDING:
      return {
        ...state,
        pending: true,
        error: {},
        customer: {},
        logged_in: false
      };

    case FETCH_VOUCHERCODE_REJECTED:
      return {
        ...state,
        error: { voucher_code: action.error.response.data.non_field_errors }
      };

    case FETCH_BASKET_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_CUSTOMER_FULFILLED:
      return {
        ...state,
        customer: action.response,
        logged_in: true
      };

    case FETCH_BASKET_FULFILLED:
      return {
        ...state,
        basket: action.response.basket,
        basketItems: action.response.basket.basketitem_set,
        pending: false,
        error: {}
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/basket.js